import Vue from 'vue';
import XInputTextField from "@/components/XInputTextField.vue";
import Loading from "@/components/partials/Loading.vue";
import XBtn from "@/components/XBtn.vue";
import XModal from "@/components/XModal.vue";
import ErrorCard from "@/components/partials/ErrorCard.vue";
import XSelect from "@/components/XSelect.vue";
import XOverlay from "@/components/XOverlay.vue";

Vue.component('VcsModal', XModal);
Vue.component('VcsTextField', XInputTextField);
Vue.component('VcsLoading', Loading);
Vue.component('VcsBtn', XBtn);
Vue.component('ErrorCard', ErrorCard);
Vue.component('VcsSelect', XSelect);
Vue.component('VcsOverlay', XOverlay)
